import {transactionsSlice} from './slice';

export * from './slice';
export * from './selectors';
export default transactionsSlice.reducer;
